import { platformClient } from './platform.client';
import type { EffectiveBranding } from './branding.types';

export type { EffectiveBranding, SchoolBrandingDisplay } from './branding.types';
export {
  mapEffectiveBranding,
  platformBrandingFallback,
  resolveBrandingAssetUrl,
  DEFAULT_PLATFORM_LOGO_URL,
} from './branding.types';


export const getMyBranding = async (): Promise<EffectiveBranding> => {
  const response = await platformClient.get<EffectiveBranding>('/me/branding');
  return response.data;
};

export const getPublicBranding = async (tenantId?: string): Promise<EffectiveBranding> => {
  const params = tenantId?.trim() ? { tenant_id: tenantId.trim() } : undefined;
  const response = await platformClient.get<EffectiveBranding>('/platform/public/branding', { params });
  return response.data;
};

export const uploadSchoolLogo = async (schoolId: string, file: File): Promise<EffectiveBranding> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await platformClient.post<EffectiveBranding>(
    `/schools/${schoolId}/branding/logo`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
  return response.data;
};
